import React, { useState, useEffect, useRef, useCallback } from "react";
import Markdown from "./Markdown";

export default function CompInputSentenceExplanation({ sentenceId, languageId }) {
  const [status, setStatus] = useState(null);
  const [text, setText] = useState(null);
  const [error, setError] = useState(null);
  const pollRef = useRef(null);

  const url = `/api/v1/comp-input-sentences/${sentenceId}/explanation?language_id=${languageId}`;

  const fetchExplanation = useCallback(() => {
    $.ajax({ url })
      .done((data) => {
        const { text: t, status: s } = data.explanation;
        setText(t);
        setStatus(s);

        if (s === "pending" || s === "working") {
          pollRef.current = setTimeout(fetchExplanation, 1000);
        } else if (s === "failed") {
          setError("There was an error generating the explanation. Please try again.");
        } else if (!s && !t) {
          // No record exists yet — auto-generate
          generate();
        }
      })
      .fail(() => {
        setError("There was an error loading the explanation. Please try again.");
      });
  }, [url]);

  const generate = useCallback(() => {
    setError(null);
    setStatus("pending");
    setText(null);

    $.ajax({ url, method: "POST" })
      .done(() => {
        pollRef.current = setTimeout(fetchExplanation, 1000);
      })
      .fail(() => {
        setError("There was an error starting the explanation. Please try again.");
      });
  }, [url, fetchExplanation]);

  useEffect(() => {
    fetchExplanation();
    return () => clearTimeout(pollRef.current);
  }, []);

  if (error) {
    return (
      <div>
        <div className="alert alert-danger">{error}</div>
        <button className="btn btn-default" onClick={generate}>Retry</button>
      </div>
    );
  }

  if (status === "complete" && text) {
    return <Markdown>{text}</Markdown>;
  }

  if (text) {
    return (
      <div>
        <Markdown>{text}</Markdown>
        <p className="text-muted"><span className="glyphicon glyphicon-refresh spinning"></span> Generating...</p>
      </div>
    );
  }

  return (
    <p className="text-muted"><span className="glyphicon glyphicon-refresh spinning"></span> Generating explanation...</p>
  );
}
